<app-material-tabs *ngIf="hasTabs" [tabs]="tabs"></app-material-tabs>
<ng-content *ngIf="hasHeader" select="app-material-header"></ng-content>
<ng-content select="app-material-body"></ng-content>
<ng-content *ngIf="hasFooter" select="app-material-footer"></ng-content>
